<div class="navbar min-h-0 py-1 bg-base-100/90 backdrop-blur sticky top-0 z-50 shadow-lg border-b border-base-300">
  <div class="flex-1 min-w-0 overflow-hidden">
    <a class="btn btn-ghost normal-case text-xl sm:text-2xl font-extrabold px-2" (click)="goHome()">
      <span class="dice-chip mr-2 hidden sm:inline-flex"><span class="dice-pip"></span></span>
      KnuffelBoard
      <span class="ml-2 text-sm font-normal opacity-70 align-middle hidden lg:inline">v{{version}} ({{versionDate}})</span>
    </a>
  </div>
  <div class="flex-none gap-1 sm:gap-2 pr-2 sm:pr-4">
    <button class="btn btn-sm btn-ghost px-2 sm:px-3" (click)="showHighscores()">
      <span aria-hidden="true">🏆</span><span class="hidden sm:inline ml-1">Highscores</span>
    </button>
    <button class="btn btn-sm btn-ghost px-2 sm:px-3" (click)="showStats()">
      <span aria-hidden="true">📊</span><span class="hidden sm:inline ml-1">Statistiken</span>
    </button>
    <button class="btn btn-sm btn-primary px-2 sm:px-3" (click)="showHistory()">
      <span aria-hidden="true">🕐</span><span class="hidden sm:inline ml-1">Historie</span>
    </button>

    @if (currentUser(); as user) {
      <span class="hidden sm:inline text-sm opacity-70 pl-2">
        {{ user.displayName }}
      </span>
    }
    @if (currentUser()) {
      <button
        class="btn btn-sm btn-ghost"
        title="Abmelden"
        (click)="logout()">
        Abmelden
      </button>
    }

    @if (canManageUsers()) {
      <button
        class="btn btn-sm btn-ghost btn-circle"
        title="Einstellungen und Benutzerverwaltung"
        aria-label="Einstellungen und Benutzerverwaltung"
        (click)="showSettings()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="1.8">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
      </button>
    }
  </div>
</div>

<main class="w-full max-w-none px-4 py-3 md:py-4">
  @if (sessionLoaded() && !requiresLogin()) {
    <router-outlet></router-outlet>
  }
</main>

@if (sessionLoaded() && requiresLogin()) {
  <app-login></app-login>
}

<app-highscore-modal [open]="isHighscores()" [onClose]="closeHighscores"></app-highscore-modal>
<app-stats-modal [open]="isStats()" [onClose]="closeStats"></app-stats-modal>
<app-settings-modal [open]="isSettings()" [onClose]="closeSettings"></app-settings-modal>
